import { useTheme } from "@emotion/react";
import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";
import { Variant } from "scmp-sdk/components/newsletter/newsletter-widget/enums";
import { getTriggerPoint } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import {
  CheckEmailMessage,
  Container,
  Footer,
  IconContainer,
  SeeMoreLink,
  StyledFollowUsOnFacebook,
  StyledIconTickCircle,
  Title,
} from "./styles";

// TODO: missing acquisition part here

export const SignUpSuccessMessage: React.FunctionComponent = ({ ...props }) => {
  const { handleRoutePush, handleTrackGA4 } = useSdkContext();
  const { signUpSuccess } = useTheme() as unknown as ThemeType;
  const { campaignName, variant } = useNewsletterContext();

  const computedEmailMessage =
    variant === Variant.AcquisitionNewsletterPopup
      ? "Please check the email for further details."
      : "Please check your email to confirm your subscription.";
  const computedTitle =
    variant === Variant.AcquisitionNewsletterPopup
      ? "Thank you for your registration."
      : "Thanks for signing up to our newsletter!";
  return (
    <Container {...props}>
      <IconContainer>
        <StyledIconTickCircle height={25} width={25} />
      </IconContainer>
      <Title>{computedTitle}</Title>
      <Footer>
        {signUpSuccess?.hasCheckEmail && (
          <CheckEmailMessage>{computedEmailMessage}</CheckEmailMessage>
        )}
        {signUpSuccess?.hasSeeMoreLinks && (
          <SeeMoreLink
            onClick={event => {
              event.preventDefault();
              handleTrackGA4({
                action: "click",
                category: "nl",
                customized_parameters: {
                  internal_campaign: campaignName ?? "",
                  trigger_point: getTriggerPoint(variant),
                },
                subcategory: "entry",
              });
              void handleRoutePush("/newsletters");
            }}
          >
            See more newsletters
          </SeeMoreLink>
        )}
        <StyledFollowUsOnFacebook />
      </Footer>
    </Container>
  );
};

SignUpSuccessMessage.displayName = "SignUpSuccessMessage";
